import store from '@/store'

export default [
  {
    path: '/attendance-devices',
    name: 'attendance-device',
    meta: { requiresAuth: true },
    component: () => import('@/pages/attendance-device/index.vue')
  }
]
